import { render } from "./TwoFaResetCodeConfirmCopy.vue?vue&type=template&id=64af7f5a"
import script from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js"
export * from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TwoFaReset/TwoFaResetCodeConfirmCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64af7f5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64af7f5a', __exports__)) {
    console.log('reload')
    api.reload('64af7f5a', __exports__)
  }
  
  module.hot.accept("./TwoFaResetCodeConfirmCopy.vue?vue&type=template&id=64af7f5a", () => {
    console.log('re-render')
    api.rerender('64af7f5a', render)
  })

}


export default __exports__